import { IPerformDocumentLoginDTO } from 'modules/authentication/domain/dtos';
import { IUserSessionsRepository } from 'modules/authentication/domain/repositories';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class PerformDocumentLoginUseCase {
  constructor(
    private sessionsRepository: IUserSessionsRepository,
    private httpProvider: IHTTPProvider,
  ) {}

  public async execute({ document }: IPerformDocumentLoginDTO) {
    const { auth, session } = await this.sessionsRepository.create({
      type: 'DOCUMENT',
      document,
    });

    this.httpProvider.setHeader('AUTHENTICATION', `Bearer ${auth.accessToken}`);

    return session;
  }
}
